import React from "react";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert } from "react-bootstrap";

const AlertInfo = ({ children }) => {
  return (
    <Alert variant={"info"} className="d-flex flex-row">
      <FontAwesomeIcon icon={faInfoCircle} size="2x" className="mr-3" />
      {children}
    </Alert>
  );
};

export default AlertInfo;
